export default __webpack_public_path__ + "static/media/work-5.e3c83a89.svg";